<organization-select #orgManager autoSelectFirst="true" class="mr-3"></organization-select>

<div class="mt-3">
    <div class="jumbotron">
        
        <autocomplete (onChange)="operatorChange($event)" #autocompleteManager [org]="orgManager?.currentValue"></autocomplete>
        <span translate>help.page.operator_device.description</span>
    </div>

    <custom-table   #operatorCounterTable *ngIf="values"
                    table_id            =   "operatorCounterTable"
                    no_title_value      =   "tables.operator_counter.no_title_value"
                    title_single        =   "tables.operator_counter.title_single"
                    title_multiple      =   "tables.operator_counter.title"
                    [filter_columns]    =   "false"
                    search_title        =   "tables.operator_counter.search_title"
                    [columns]           =   "operatorCounterColumns"
                    [values]            =   "values"
                    ></custom-table>
    <!--
    <text-card [operator]="autocompleteManager?.currentValue"></text-card>
    -->
</div>